import { AlpineComponent } from '@alpinejs/csp';

const InfoCards = (): AlpineComponent => ({
  isMobile: false,
  handleIsMobile() {
    this.isMobile = window.innerWidth < 960;
  },
  init() {
    this.handleIsMobile();
  },
  getTabIndex() {
    return !this.isMobile ? -1 : 0;
  },
  isOpen() {
    return !this.isMobile;
  }
});

export default InfoCards;
